<template>
  <div class="im-info-user">
    <Avatar :image="data.photoUrl"/>
    <div class="im-info-user__rating-name">
      <Rating :rating="+data.maxPrivLevel"/>
      <a :href="data.profileUrl" class="im-info-user__name">{{ data.name }}</a>
    </div>
    <div class="im-info-user__visited">Последний раз был(a): {{ visit }}</div>
    <Actions :data="data"/>
  </div>
</template>

<script>
  import Avatar from './avatar/Avatar.vue';
  import Rating from './rating/Rating.vue';
  import Actions from './actions/Actions.vue';

  export default {
    name: 'User',
    components: {
      Avatar,
      Actions,
      Rating,
    },
    props: {
      data: {
        type: Object,
        default: function () {
          return {
            ID: null,
            isFriend: null,
            isFriendSuggestion: null,
            isIgnored: null,
            lastVisit: {
              sectionName: null,
              sectionUrl: null,
              textAgo: null
            },
            maxPrivLevel: null,
            name: null,
            photoUrl: null,
            profileUrl: null
          };
        }
      }
    },
    computed: {
      visit() {
        const data = this.data.lastVisit;
        return `${data.sectionName} ${data.textAgo} `;
      }
    }
  };
</script>

<style lang="scss">
  .im-info-user {
    padding: 0 0 8px;

    &__avatar {
      display: flex;
      justify-content: center;
      margin: 0 0 20px;
      width: 100%;
    }

    &__image {
      background: #DADADA;
      border-radius: 50%;
      overflow: hidden;
      width: 100px;
      height: 100px;

      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }

      svg {
        width: 100px;
        height: 100px;
      }
    }

    &__rating-name {
      display: flex;
      align-items: center;
      margin: 0 0 12px;
    }

    &__name {
      margin: 0 0 0 6px;
      font-size: 12px;
      font-weight: bold;
    }
  }
</style>